import {lazy} from "react";
import {Navigate, Outlet} from "react-router-dom";
// auth
import {AuthGuard, TransactionHistoryGuard} from "src/auth/guard";
// routes
import {paths} from "src/routes/paths";
// layouts
import DashboardLayout from "src/layouts/dashboard";
import ErrorBoundary from "src/layouts/dashboard/error-boundary";

// ----------------------------------------------------------------------

// HOME
const DashboardHomePage = lazy(() => import("src/pages/dashboard/home"));
// TASKS
const TaskManagerPage = lazy(() => import("src/pages/dashboard/tasks"));
// BILLING
const BillingPage = lazy(() => import("src/pages/dashboard/billing"));
const BillingRechargeHistoryPage = lazy(() => import("src/pages/dashboard/billing-recharge-history"));
// API
const ApiKeysPage = lazy(() => import("src/pages/dashboard/api-set-up/api-keys"));
const WebhooksPage = lazy(() => import("src/pages/dashboard/api-set-up/webhooks"));
// SHIPMENTS
const LabelPage = lazy(() => import("src/pages/dashboard/shipments/label"));
const PickupPage = lazy(() => import("src/pages/dashboard/shipments/pickup"));
const ScanFormPage = lazy(() => import("src/pages/dashboard/shipments/scan-form"));
// SETTINGS
const SettingsAccountPage = lazy(() => import("src/pages/dashboard/settings/account"));
const SettingsTransactionHistoryPage = lazy(() => import("src/pages/dashboard/settings/transaction-history"));
const SettingsCarriersPage = lazy(() => import("src/pages/dashboard/settings/carriers"));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
    {
        path: "/",
        element: (
            <AuthGuard>
                <ErrorBoundary>
                    <DashboardLayout>
                        <Outlet/>
                    </DashboardLayout>
                </ErrorBoundary>
            </AuthGuard>
        ),
        children: [
            {path: "", element: <Navigate to={paths.dashboard.home} replace/>},
            {path: "home", element: <DashboardHomePage/>},
            {path: "tasks", element: <TaskManagerPage/>},
            //
            {
                path: "billing",
                children: [
                    {path: "", element: <BillingPage/>, index: true},
                    {path: "recharge-history", element: <BillingRechargeHistoryPage/>}
                ]
            },
            //
            {
                path: "api",
                children: [
                    {path: "key", element: <ApiKeysPage/>, index: true},
                    {path: "webhooks", element: <WebhooksPage/>}
                ]
            },
            {
                path: "shipping",
                children: [
                    {path: "shipments", element: <LabelPage/>, index: true},
                    {path: "pickups", element: <PickupPage/>},
                    {path: "scan_form", element: <ScanFormPage/>}
                ]
            },
            {
                path: "settings",
                children: [
                    {path: "profile", element: <SettingsAccountPage/>},
                    {
                        path: "transaction_history",
                        element: (
                            <TransactionHistoryGuard>
                                <SettingsTransactionHistoryPage/>
                            </TransactionHistoryGuard>
                        )
                    },
                    {path: "carriers", element: <SettingsCarriersPage/>, index: true}
                ]
            }
        ]
    }
];
